import { atvaltasFelirat, tolcserLepesek, type TolcserBemenet } from './tolcser.ts';

export interface TolcserProps {
  /** A lépések sorrendben; az első a 100%. A `cimke` a megjelenített név. */
  lepesek: readonly (TolcserBemenet & { cimke: string })[];
}

const MAGASSAG_PX = 180;

/** Az Elemzés tölcsére: asztalon oszlopok, mobilon sávok; a lépés neve alatt az átváltási arány az előzőből. */
export default function Tolcser({ lepesek }: TolcserProps) {
  const adatok = tolcserLepesek(lepesek);
  return (
    <ol className="mt-6 grid gap-2.5 md:grid-flow-col md:auto-cols-fr md:items-end md:gap-0">
      {adatok.map((l, i) => (
        <li key={l.lepes} className="relative grid grid-cols-[3.5rem_1fr] items-center gap-x-3 md:block md:pr-3.5">
          <b className="szam-nagy row-span-2 text-2xl md:mb-2.5 md:block md:text-[34px]">{l.db}</b>
          <span
            aria-hidden
            className="block h-2.5 w-(--szel) rounded-[5px] md:h-(--magassag) md:w-auto md:rounded-t-[10px] md:rounded-b-[4px]"
            style={{ ['--magassag' as string]: `${Math.max(6, Math.round(l.arany * MAGASSAG_PX))}px`, ['--szel' as string]: `max(6px, ${l.arany * 100}%)`, background: 'var(--sav-atmenet)', backgroundSize: '600% 100%', backgroundPosition: `${(i / Math.max(1, adatok.length - 1)) * 100}% 0` }}
          />
          <span className="mt-1 block text-sm text-szoveg-halk md:mt-2.5">{l.cimke}</span>
          {l.atvaltas !== null && (
            <span className="col-start-2 mt-0.5 block text-xs text-szoveg-halk/70 md:mt-1">{atvaltasFelirat(l.atvaltas)}</span>
          )}
        </li>
      ))}
    </ol>
  );
}
